import myAxios from "./axiositeachWrapper";
import Config from "../_config/config";

/**
 * Cumulative Test Report service (iteach).
 * Talks to the nodefork endpoints that port the Java
 * studentTestReport.do?reqCode=preCumulativeTestReportNew flow.
 */

export interface IdName {
  id: number;
  name: string;
}

export interface CumulativeReportFiltersData {
  schools: IdName[];
  years: IdName[];
  categories: IdName[];
  testTypes: IdName[];
}

export interface DownloadPayload {
  centerIds: number[];
  yearIds: number[];
  courseIds: number[];
  testCategoryId: number;
  testIds: string; // comma-separated, e.g. "1,2,3"
}

export interface DownloadResponse {
  success: boolean;
  url?: string | null;
  key?: string | null;
  error?: string;
}

class CumulativeTestReportService {
  private base = `${Config.nodeSiteUrl}v1/reports/cumulative-test`;

  /** Static dropdowns: schools, years, test categories, test types. */
  async getFilters(): Promise<CumulativeReportFiltersData> {
    const res = await (myAxios as any).get(`${this.base}/filters`);
    const data = res?.data?.data || {};
    return {
      schools: data.schools || [],
      years: data.years || [],
      categories: data.categories || [],
      testTypes: data.testTypes || [],
    };
  }

  /** Courses for the selected centre(s). Mirrors filterCoursesDropdown(). */
  async getCoursesByCenter(centerIds: number[]): Promise<IdName[]> {
    const res = await (myAxios as any).post(`${this.base}/courses-by-center`, {
      centerIds,
    });
    return res?.data?.data || [];
  }

  /** Tests matching the filters. Mirrors filterTestDropdown(). */
  async getTestsByFilters(params: {
    centerIds: number[];
    yearIds: number[];
    courseIds: number[];
    testCategoryId: number;
    testTypeId: number;
  }): Promise<{ tests: IdName[]; error?: string }> {
    const res = await (myAxios as any).post(`${this.base}/tests-by-filters`, params);
    const body = res?.data || {};
    return { tests: body.data || [], error: body.success ? undefined : body.error };
  }

  /** Build + run the report. Mirrors the JSP search() POST. */
  async download(payload: DownloadPayload): Promise<DownloadResponse> {
    const res = await (myAxios as any).post(`${this.base}/download`, payload);
    return res?.data as DownloadResponse;
  }
}

export default new CumulativeTestReportService();
